<template>
  <div class="column">
    <woot-modal-header :header-title="$t('AI.KNOWLEDGE.FILTERS.TITLE')">
      <p>{{ $t('AI.KNOWLEDGE.FILTERS.SUB_TITLE') }}</p>
    </woot-modal-header>
    <div class="row modal-content">
      <div class="small-12 medium-12 columns filters-wrap">
        <filter-input-box
          v-for="(filter, i) in appliedFilters"
          :key="i"
          v-model="appliedFilters[i]"
          :filter-attributes="filterAttributes"
          :input-type="getInputType(appliedFilters[i].attribute_key)"
          :operators="getOperators(appliedFilters[i].attribute_key)"
          :dropdown-values="getDropdownValues(appliedFilters[i].attribute_key)"
          :show-query-operator="i !== appliedFilters.length - 1"
          :show-user-input="showUserInput(appliedFilters[i].filter_operator)"
          :v="$v.appliedFilters.$each[i]"
          @resetFilter="resetFilter(i, appliedFilters[i])"
          @removeFilter="removeFilter(i)"
        />
        <div class="filter-actions">
          <woot-button
            icon="add"
            variant="smooth"
            size="small"
            @click="appendNewFilter"
          >
            {{ $t('CONTACTS_FILTER.ADD_NEW_FILTER') }}
          </woot-button>
          <woot-button
            icon="subtract"
            color-scheme="alert"
            variant="smooth"
            size="small"
            @click="clearFilters"
          >
            {{ $t('CONTACTS_FILTER.CLEAR_ALL_FILTERS') }}
          </woot-button>
        </div>
      </div>
      <div class="small-12 medium-12 columns">
        <div class="modal-footer justify-content-end w-full">
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t('CONTACTS_FILTER.CANCEL_BUTTON_LABEL') }}
          </woot-button>
          <woot-button @click="submitFilterQuery">
            {{ $t('CONTACTS_FILTER.SUBMIT_BUTTON_LABEL') }}
          </woot-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { required, requiredIf } from 'vuelidate/lib/validators';
import FilterInputBox from 'components/widgets/FilterInput/Index.vue';
import { KNOWLEDGE_TYPE_LIST } from '../ai.constant';
import filterMixin from 'shared/mixins/filterMixin';

export default {
  components: {
    FilterInputBox,
  },
  mixins: [alertMixin, filterMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    filterItems: {
      type: Array,
      default: () => [],
    },
    initialAppliedFilters: {
      type: Array,
      default: () => [],
    },
    filterAttributes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
      appliedFilters: [
        {
          attribute_key: 'name',
          filter_operator: 'equal_to',
          values: '',
          query_operator: 'and',
        },
      ],
      filterTypes: this.filterItems,
      filterGroups: [],
    };
  },
  validations: {
    appliedFilters: {
      required,
      $each: {
        values: {
          required: requiredIf(prop => {
            return !(
              prop.filter_operator === 'is_present' ||
              prop.filter_operator === 'is_not_present'
            );
          }),
        },
      },
    },
  },
  watch: {
    initialAppliedFilters: {
      handler(newVal) {
        if (newVal?.length) {
          this.appliedFilters = JSON.parse(JSON.stringify(newVal));
        } else {
          // Reset to default filter when cleared
          this.appliedFilters = [
            {
              attribute_key: 'name',
              filter_operator: 'equal_to',
              values: '',
              query_operator: 'and',
            },
          ];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.initialAppliedFilters?.length) {
      this.appliedFilters = JSON.parse(
        JSON.stringify(this.initialAppliedFilters)
      );
    }
  },
  methods: {
    submitFilterQuery() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$emit('applyFilter', this.appliedFilters);
    },
    getInputType(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.inputType;
    },
    getOperators(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.filterOperators;
    },
    getDropdownValues(type) {
      switch (type) {
        case 'kind':
          return KNOWLEDGE_TYPE_LIST.map(el => ({
            ...el,
            name: this.$t(el.title),
          }));
        default:
          return undefined;
      }
    },
    showUserInput(operatorType) {
      if (operatorType === 'is_present' || operatorType === 'is_not_present')
        return false;
      return true;
    },
    resetFilter(index, currentFilter) {
      this.appliedFilters[index].filter_operator = this.filterTypes.find(
        filter => filter.attributeKey === currentFilter.attribute_key
      ).filterOperators[0].value;
      this.appliedFilters[index].values = '';
    },
    removeFilter(index) {
      if (this.appliedFilters.length <= 1) {
        this.showAlert(this.$t('CONTACTS_FILTER.FILTER_DELETE_ERROR'));
      } else {
        this.appliedFilters.splice(index, 1);
      }
    },
    appendNewFilter() {
      this.appliedFilters.push({
        attribute_key: 'name',
        filter_operator: 'equal_to',
        values: '',
        query_operator: 'and',
      });
    },
    clearFilters() {
      this.$emit('clearFilters');
      this.onClose();
    },
  },
};
</script>

<style></style>
